import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const accessToken = this.getJwtToken();

    if (accessToken && !request.url.endsWith('ValidateToken')) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${accessToken}` },
      });
    }

    return next.handle(request);
  }

  private getJwtToken(): string | null {
    const directToken = localStorage.getItem('access_Token') || localStorage.getItem('token');
    if (directToken) {
      return directToken;
    }

    for (let index = 0; index < localStorage.length; index++) {
      const key = localStorage.key(index);
      if (!key) {
        continue;
      }

      const value = localStorage.getItem(key);
      if (!value) {
        continue;
      }

      try {
        const parsedValue = JSON.parse(value) as { authToken?: string };
        if (parsedValue?.authToken) {
          return parsedValue.authToken;
        }
      } catch {
        continue;
      }
    }

    return null;
  }
}
